import React, { useState } from "react";
import logoImage from "../assets/logo.svg";
import { Button } from "./Button/Button";
import { navData } from "../data/NavData";
import { AiOutlineClose } from "react-icons/ai";
import { HiOutlineMenu } from "react-icons/hi";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [logo, setLogo] = useState(false);

  const handleNav = () => {
    setNav(!nav);
    setLogo(!logo);
  };

  return (
    <div className="flex w-full justify-between items-center h-20 px-4 md:px-24 lg:px-28 fixed z-10 bg-white">
      <div>
        <div
          onClick={handleNav}
          className={logo ? "hidden" : "flex items-center"}
        >
          <img src={logoImage} alt="logo" />
          <h2 className="ml-2 md:ml-2">WalletCloud</h2>
        </div>
      </div>
      <ul className="hidden md:flex items-center">
        <a
          href="#home"
          className="mr-6 text-[#219653] text-base sm:font-medium"
        >
          Home
        </a>
        {navData.map((item, index) => (
          <li className="">
            <a href={`${item.link}`} key={index}>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
      <div className="hidden md:flex items-center">
        <a
          href="/login"
          className="mr-6 text-[#219653] text-base sm:font-medium"
        >
          Login
        </a>
        <Button primary={true} big={true} to="/developers">
          Get the API
        </Button>
      </div>

      {/* Hamburger */}
      <div className="lg:hidden z-10" onClick={handleNav}>
        {nav ? (
          <AiOutlineClose className="text-black" size={25} />
        ) : (
          <HiOutlineMenu size={25} />
        )}
      </div>

      {/* Mobile menu dropdown */}
      <div
        onClick={handleNav}
        className={
          nav
            ? "fixed text-black left-0 top-0 w-full bg-gray-100/90 px-8 py-7 md:hidden"
            : "fixed left-[-100%]"
        }
      >
        <a
          href="#home"
          id="#home"
          className="w-full mb-4 decoration-0 flex flex-row items-center"
        >
          <img src={logoImage} alt="logo" />
          <h2 className="ml-2">WalletCloud</h2>
        </a>

        <a
          href="#home"
          className="ml-4 pb-2 text-[#219653] text-sm sm:text-base border-b"
        >
          Home
        </a>
        {navData.map((item, index) => (
          <li className="list-none border-b">
            <a href={`${item.link}`} key={index}>
              {item.title}
            </a>
          </li>
        ))}
        <div className="flex flex-col">
          <button className="my-6 p-3 bg-white text-[#219653] border-[#219653] rounded-md">
            Login
          </button>
          <button className="hover:-translate-y-1">Get the API</button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
